
import { useEffect, useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutContent from './components/AboutContent';
import WhyChooseUs from './components/WhyChooseUs';
import TeamSection from './components/TeamSection';
import Testimonials from './components/Testimonials';
import { useSEO, generateWebPageSchema, generateAboutPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function AboutPage() {
  const [scrolled, setScrolled] = useState(false);
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'About Brushour | Painters & Decorators Watford Hertfordshire',
    description: 'Learn about Brushour – professional painters and decorators in Watford, Hertfordshire with 18+ years of experience and 500+ satisfied customers. Fully insured, local experts serving Hertfordshire and surrounding areas.',
    keywords: 'about Brushour, painters Watford, decorators Hertfordshire, painting company Watford, professional decorators Hertfordshire',
    canonical: `${SITE_URL}/about`,
    schema: [
      generateAboutPageSchema(),
      generateWebPageSchema('About Brushour – Painters & Decorators Watford', 'Learn about our 18+ years of experience in professional painting and decorating services across Watford and Hertfordshire', `${SITE_URL}/about`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'About', url: `${SITE_URL}/about` },
      ]),
    ],
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <main>
        <AboutHero />
        <AboutContent />
        <WhyChooseUs />
        <TeamSection />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
